import React from "react";

import {
    Edit as EditIcon,
} from "@material-ui/icons";
import DataTable from "../../../components/data-table";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import FormModalContent from "./form";

const defaultKeys = [
    {
        field: "name",
        title: "عنوان",
        active: true,
    },
];

export default function TagsPage() {
    const { initials } = useSelector((state) => state.app);

    const headerCells = useMemo(
        () => [
            {
                field: "originalName",
                title: "عنوان",
                mainField: true,
            },
            {
                field: "search_keys",
                title: "هم خانواده",
            },
            {
                field: "refName",
                title: "جنس تگ",
            }
        ],
        [initials]
    );

    return (
        <div className="p-3">
            <DataTable
                headCells={headerCells}
                backend={"/tags"}
                rowActions={[
                    {
                        modalProps: { maxWidth: "md" },
                        icon: <EditIcon />,
                        modalContent: (props) => <FormModalContent {...props} />,
                    },
                ]}
                orderBy="createDate"
                searchKeys={defaultKeys}
                title="تگ ها"
            />
        </div>
    );
}
